import axios from 'axios'
import {
  EquipmentModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
} from '../model'
import {TableResumen} from '../../central/model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getEquipment(dto: EquipmentModel, page: number) {
  return axios.post<ResponseObjectPaginated<EquipmentModel[]>>(
    `${BASEURL}/machine/getAll/${page}`,
    dto,
  )
}
export function getEquipmentById(dto: string | undefined) {
  return axios.get<ResponseObject<EquipmentModel>>(
    `${BASEURL}/machine/getInformationById?pointId=${dto}`,
  )
}

export function createEquipment(dto: EquipmentModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/machine/createMachine`, dto)
}

export function deleteEquipment(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/machine/deleteMachine?id=${dto}`)
}

export function updateEquipment(dto: EquipmentModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/machine/updateMachine`, dto)
}
export function getEquipmentByPoint(page: number, id: any) {
  return axios.get<ResponseObjectPaginated<EquipmentModel[]>>(
    `${BASEURL}/profile/getAllOptionsByPermission?vistaPermisoId=${id}&pageNumber=${page}`,
  )
}

// INICIO ---- SERVICIOS MASIVE

// export function downloadTemplateEquipment() {
//   return axios.post<ResponseObjectURL>(`${BASEURL}/machine/downloadTemplateBulkLoad`)
// }

export function downloadTemplateEquipment() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/machine/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveEquipment(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/machine/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
